import { useMemo } from 'react';
import SiteLayout from '@/components/feature/SiteLayout';
import { usePageMeta } from '@/hooks/usePageMeta';
import { SITE_EMAIL, SITE_NAME } from '@/mocks/site';
import AboutHero from '@/pages/about/components/AboutHero';
import PositionSection from '@/pages/about/components/PositionSection';
import PrinciplesSection from '@/pages/about/components/PrinciplesSection';
import AboutVoices from '@/pages/about/components/AboutVoices';
import ContactSection from '@/pages/about/components/ContactSection';

export default function About() {
  const jsonLd = useMemo(
    () => [
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于爆料大赛赛程站 - 品牌介绍与内容原则',
        description:
          '爆料大赛赛程站的品牌介绍、网站定位、发展理念、内容原则、用户口碑与联系方式。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        name: `${SITE_NAME}赛程站`,
        description: '专注发布爆料大赛赛程时间表、活动安排与比赛进度的赛事信息站点。',
        email: SITE_EMAIL,
      },
      {
        '@context': 'https://schema.org',
        '@type': 'ContactPage',
        name: '联系爆料大赛赛程站',
        description: '通过留言表单或邮箱咨询爆料大赛赛程、活动安排与比赛进度相关问题。',
        inLanguage: 'zh-CN',
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          { '@type': 'ListItem', position: 1, name: '首页', item: '/' },
          { '@type': 'ListItem', position: 2, name: '关于我们', item: '/about' },
        ],
      },
    ],
    [],
  );

  usePageMeta({
    title: '关于我们 - 爆料大赛赛程站的品牌介绍与内容原则',
    description:
      '了解爆料大赛赛程站：我们的网站定位、品牌介绍、发展理念与四条内容原则，以及用户口碑与联系方式。留言咨询赛程与活动安排相关问题。',
    keywords: '爆料大赛,爆料大赛赛程,爆料大赛活动安排,爆料大赛日程',
    path: '/about',
    jsonLd,
  });

  return (
    <SiteLayout>
      <AboutHero />
      <PositionSection />
      <PrinciplesSection />
      <AboutVoices />
      <ContactSection />
    </SiteLayout>
  );
}